import PageLayout from "lib/components/PageLayout";
import Head from "lib/components/Head";
import { Benefits } from "domain/pro/ui/benefits/benefits";
import { Hero } from "domain/pro/ui/hero/hero";
import { Features } from "domain/pro/ui/features/features";
import { FinalAppeal } from "domain/pro/ui/final-appeal/final-appeal";

const LawfullyPro = () => {
  return (
    <PageLayout>
      <Head
        title="Lawfully Pro"
        desc="Lawfully Pro simplifies USCIS case tracking for law firms and institutions. Manage clients, cases and enhance your firm’s visibility with our secure platform. Improve your immigration services today."
        url="/pro"
      >
        <link
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard-dynamic-subset.min.css"
          rel="stylesheet"
        />
      </Head>

      <Hero />
      <Benefits />
      <Features />
      <FinalAppeal />
    </PageLayout>
  );
};

export default LawfullyPro;
